// Uncomment the below to migrate to statefull component
// import LayoutContainer from './LayoutContainer'
import Layout from './Layout'

export { Layout }
export default Layout
// Uncomment the below to migrate to statefull component
// export { LayoutContainer }
// export default { LayoutContainer }



// WEBPACK FOOTER //
// ./src/components/Layout/index.js